var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22 22",
    style: {
      enableBackground: "new 0 0 22 22"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4,18c0.1,0.1,0.3,0.2,0.5,0.2c0.2,0,0.4-0.1,0.5-0.2L15,8c0.3-0.3,0.3-0.8,0-1.1c-0.3-0.3-0.8-0.3-1,0L4,17 C3.7,17.3,3.7,17.7,4,18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7,2.8l-1.5-1.5c-0.6-0.6-1.4-0.9-2.3-0.9c-0.9,0-1.7,0.3-2.3,0.9l-1.1,1.1c-0.3,0.3-0.3,0.8,0,1.1l5,5 c0.1,0.1,0.3,0.2,0.5,0.2c0.2,0,0.4-0.1,0.5-0.2l1.1-1.1C21.9,6.1,21.9,4.1,20.7,2.8z M19.6,6.3L19,6.9l-4-4l0.6-0.6 c0.3-0.3,0.8-0.5,1.2-0.5c0.5,0,0.9,0.2,1.2,0.5l1.5,1.5C20.3,4.6,20.3,5.7,19.6,6.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9,9L6.6,19.4L2,20l0.6-4.6l9.9-9.9c0.3-0.3,0.3-0.8,0-1.1c-0.3-0.3-0.8-0.3-1.1,0L1.4,14.6 c-0.1,0.1-0.2,0.3-0.2,0.4l-0.8,5.8c0,0.2,0,0.5,0.2,0.6c0.1,0.1,0.3,0.2,0.5,0.2c0,0,0.1,0,0.1,0L7,20.8c0.2,0,0.3-0.1,0.4-0.2 L18,10.1c0.3-0.3,0.3-0.8,0-1.1C17.7,8.7,17.2,8.7,16.9,9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c685c8c0b9134082f8c7d87bad63a87f.svg";
export { ForwardRef as ReactComponent };